import { useMutation } from '@tanstack/react-query';
import { MutationKey } from '@shared/config';
import { useAuthSignIn } from '../../../hooks/useSignIn';
import { authApi } from '../../authApi';
import type { VerifiedRegistrationRequest } from '../../types';

export const useVerifiedRegister = () => {
  const signIn = useAuthSignIn();
  return useMutation({
    mutationKey: [MutationKey.AUTH_REGISTER_VERIFIED],
    mutationFn: (payload: VerifiedRegistrationRequest) =>
      authApi.registerVerified(payload),
    onSuccess: ({ data, meta }) => {
      signIn({
        tokenExpiresIn: data.expiresIn,
        token: data.accessToken,
        tokenType: data.tokenType,
        refreshToken: data.refreshToken,
        ...meta.user,
      });
    },
  });
};
